export default __webpack_public_path__ + "static/media/blind.cb209c81.jpg";